(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rv-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rv-cart-recommendations')) {
    customElements.define('rv-cart-recommendations', class extends HTMLElement {
      static cache = new Map();
      static adding = false;
      connectedCallback() {
        this.abort = new AbortController();
        this.track = this.querySelector('.rv-cart-picks__track');
        this.status = this.querySelector('.rv-cart-picks__status');
        this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
        this.format = new Intl.NumberFormat(this.dataset.locale || 'es', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.onChange = event => event.stopPropagation();
        this.onClick = event => {
          const arrow = event.target.closest('[data-direction]');
          if (arrow) this.track.scrollBy({ left: Number(arrow.dataset.direction) * (this.track.clientWidth * .8), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.onScroll = () => this.updateArrows();
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resize = new ResizeObserver(this.onScroll);
        this.resize.observe(this.track);
        this.load();
      }
      disconnectedCallback() {
        this.abort.abort();
        this.resize?.disconnect();
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('scroll', this.onScroll);
      }
      async recommended(id) {
        const key = `${this.root}:${this.dataset.currency}:${id}`;
        const cached = this.constructor.cache.get(key);
        if (cached && Date.now() - cached.time < 60000) return cached.products;
        const response = await fetch(`${this.root}recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=10&intent=related`, { signal: this.abort.signal });
        if (!response.ok) return [];
        const data = await response.json();
        const products = Array.isArray(data.products) ? data.products : [];
        this.constructor.cache.set(key, { time: Date.now(), products });
        return products;
      }
      async load() {
        let data;
        try { data = JSON.parse(this.querySelector('[data-products]').textContent); } catch { return; }
        const ids = new Set(data.cart.map(item => Number(item.id)));
        const seeds = [...ids].slice(0, 2);
        const timeout = setTimeout(() => this.abort.abort(), 7000);
        const results = await Promise.allSettled(seeds.map(id => this.recommended(id)));
        clearTimeout(timeout);
        if (!this.isConnected) return;
        const candidates = new Map();
        const add = (product, related, rank) => {
          const id = Number(product.id);
          const variants = (product.variants || []).filter(v => v.available && Number(v.price) > 0);
          if (!product.available || !variants.length || ids.has(id) || !product.featured_image || product.gift_card) return;
          const affinity = data.cart.reduce((best, item) => Math.max(best, (item.vendor && item.vendor === product.vendor ? 12 : 0) + (item.type && item.type === product.type ? 8 : 0)), 0);
          const score = (related ? 100 - rank : 0) + affinity + Math.random() * 20;
          if (!candidates.has(id) || candidates.get(id).score < score) candidates.set(id, { product, variants, score });
        };
        results.forEach(result => { if (result.status === 'fulfilled') result.value.forEach((p, i) => add(p, true, i)); });
        (data.fallback || []).forEach(p => add(p, false, 0));
        const selected = [...candidates.values()].sort((a, b) => b.score - a.score).slice(0, 8);
        if (!selected.length) return;
        selected.forEach(item => this.track.append(this.card(item.product, item.variants)));
        this.hidden = false;
        this.updateArrows();
      }
      updateArrows() {
        if (!this.track) return;
        this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft <= 2;
        this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
      card(product, variants) {
        const card = document.createElement('article');
        card.className = 'rv-cart-picks__card';
        const link = document.createElement('a');
        link.className = 'rv-cart-picks__link';
        const url = new URL(product.url || `${this.root}products/${encodeURIComponent(product.handle)}`, window.location.origin);
        link.href = url.origin === window.location.origin ? url.href : `${this.root}products/${encodeURIComponent(product.handle)}`;
        const img = document.createElement('img');
        img.className = 'rv-cart-picks__image';
        const image = new URL(typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.url, window.location.origin);
        image.searchParams.set('width', '360');
        img.src = image.href;
        img.alt = product.title;
        img.loading = 'lazy';
        img.width = 360;
        img.height = 480;
        const title = document.createElement('h3');
        title.className = 'rv-cart-picks__name';
        title.textContent = product.title;
        link.append(img, title);
        const price = document.createElement('p');
        price.className = 'rv-cart-picks__price';
        price.textContent = this.format.format(Number(variants[0].price) / 100);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rv-cart-picks__add';
        button.textContent = this.dataset.add;
        button.setAttribute('aria-label', `${this.dataset.add}: ${product.title}`);
        let selected = variants.length === 1 ? variants[0] : null;
        let choice;
        if (variants.length > 1) {
          choice = document.createElement('select');
          choice.setAttribute('aria-label', `${this.dataset.options}: ${product.title}`);
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = this.dataset.choose;
          choice.append(placeholder);
          variants.forEach(variant => {
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.textContent = variant.title;
            choice.append(option);
          });
          button.disabled = true;
          choice.addEventListener('change', () => {
            selected = variants.find(v => String(v.id) === choice.value);
            button.disabled = !selected;
            if (selected) price.textContent = this.format.format(Number(selected.price) / 100);
          });
        } else {
          choice = document.createElement('span');
          choice.textContent = variants[0].title === 'Default Title' ? '' : variants[0].title;
        }
        choice.className = 'rv-cart-picks__variant';
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (selected) this.add(selected.id, button);
        });
        card.append(link, price, choice, button);
        return card;
      }
      async add(id, button) {
        if (this.constructor.adding) return;
        this.constructor.adding = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        this.status.textContent = '';
        const drawer = document.querySelector('cart-drawer');
        const mainCart = document.querySelector('cart-items');
        const mainSections = mainCart?.getSectionsToRender() || [];
        const sections = [...new Set([...(drawer?.getSectionsToRender().map(s => s.id) || []), ...mainSections.map(s => s.section)])];
        let confirmed = false;
        let rejected = false;
        try {
          const response = await fetch(`${this.root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections, sections_url: window.location.pathname })
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            rejected = true;
            this.status.textContent = typeof data.description === 'string' ? data.description : this.dataset.error;
            return;
          }
          confirmed = true;
          button.textContent = this.dataset.added;
          if (!data.sections || sections.some(section => !data.sections[section])) {
            window.location.assign(`${this.root}cart`);
            return;
          }
          for (const section of mainSections) {
            const wrapper = document.getElementById(section.id);
            const target = wrapper?.querySelector(section.selector) || wrapper;
            if (target) target.innerHTML = mainCart.getSectionInnerHTML(data.sections[section.section], section.selector);
          }
          if (drawer) {
            drawer.classList.remove('is-empty');
            drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
            drawer.renderContents(data);
          } else {
            window.location.assign(`${this.root}cart`);
          }
        } catch {
          if (confirmed) window.location.assign(`${this.root}cart`);
          else this.status.textContent = this.dataset.uncertain;
        } finally {
          this.constructor.adding = false;
          if (rejected) { button.disabled = false; button.textContent = this.dataset.add; }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rv-category-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-rv-category-link]');
    if (link) {
      const destination = new URL(link.href);
      const current = new URL(window.location.href);
      for (const [key, value] of current.searchParams) {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id') {
          destination.searchParams.append(key, value);
        }
      }
      link.href = destination.href;
    }
    document.querySelectorAll('.rv-category-filter__details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rv-category-filter__details[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rv-free-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rv-free-shipping')) {
    customElements.define('rv-free-shipping', class extends HTMLElement {
      static privacyReady;
      static previousProgress = new Map();
      static shippingThreshold(region) {
        const value = String(region || '').toUpperCase().replaceAll('-', '');
        const country = value.slice(0, 2);
        const province = value.slice(2);
        if (country === 'ES') {
          if (['CN', 'GC', 'TF'].includes(province)) return 12000;
          const mainland = 'C AB A AL O BA PM B BU S CS CE CR CU CC CA CO GI GR GU SS H HU J LO LE L LU M ML MU MA NA OR P PO SA SG SE SO T TE TO V VA BI ZA Z VI AV AN AR AS CB CL CM CT EX GA IB RI MD MC NC PV VC'.split(' ');
          return mainland.includes(province) ? 6000 : null;
        }
        if ('BE FR DE NL PT'.split(' ').includes(country)) return 10000;
        if (country === 'IT') return 14000;
        return null;
      }
      connectedCallback() {
        this.drawer = this.closest('cart-drawer');
        this.scope = this.drawer ? 'drawer' : 'page';
        this.fill = this.querySelector('.rv-shipping__fill');
        this.wasOpen = this.drawer?.classList.contains('active') || false;
        if (this.drawer) {
          this.drawerObserver = new MutationObserver(() => {
            const open = this.drawer.classList.contains('active');
            if (open && !this.wasOpen && Number.isFinite(this.targetProgress)) {
              this.animateProgress(0, this.targetProgress);
            }
            this.wasOpen = open;
          });
          this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        }
        this.onConsent = () => this.update();
        this.onLoad = () => this.loadPrivacy();
        document.addEventListener('visitorConsentCollected', this.onConsent);
        window.addEventListener('load', this.onLoad);
        this.loadPrivacy();
      }
      disconnectedCallback() {
        this.drawerObserver?.disconnect();
        this.fillAnimation?.cancel();
        const key = this.progressKey;
        const scope = this.scope;
        queueMicrotask(() => {
          const remaining = Array.from(document.querySelectorAll('rv-free-shipping')).some(bar => bar.scope === scope);
          if (!remaining && key) this.constructor.previousProgress.delete(key);
        });
        document.removeEventListener('visitorConsentCollected', this.onConsent);
        window.removeEventListener('load', this.onLoad);
      }
      animateProgress(from, to) {
        if (!this.fill) return;
        this.fillAnimation?.cancel();
        this.fill.style.transform = `scaleX(${to / 100})`;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || from === to) return;
        this.fillAnimation = this.fill.animate(
          [{ transform: `scaleX(${from / 100})` }, { transform: `scaleX(${to / 100})` }],
          { duration: 650, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      }
      loadPrivacy() {
        if (window.Shopify?.customerPrivacy) { this.update(); return; }
        if (!window.Shopify?.loadFeatures) return;
        this.constructor.privacyReady ||= new Promise(resolve => {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => resolve(!error));
        });
        this.constructor.privacyReady.then(() => { if (this.isConnected) this.update(); });
      }
      update() {
        const message = this.querySelector('.rv-shipping__message');
        const meter = this.querySelector('.rv-shipping__meter');
        if (!message || !meter) return;
        this.hidden = true;
        this.targetProgress = undefined;
        this.fillAnimation?.cancel();
        meter.hidden = true;
        message.textContent = '';
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy?.getRegion) return;
        let region;
        try { region = String(privacy.getRegion() || '').toUpperCase().replaceAll('-', ''); } catch { return; }
        if (!/^[A-Z]{2}[A-Z0-9]{0,3}$/.test(region)) return;
        const country = region.slice(0, 2);
        const threshold = this.constructor.shippingThreshold(region);
        let name = country;
        try { name = new Intl.DisplayNames([this.dataset.locale || 'es'], { type: 'region' }).of(country); } catch {}
        if (country === 'ES' && threshold) name = threshold === 12000 ? this.dataset.canaries : this.dataset.spain;
        if (!threshold) return;
        const currency = this.dataset.currency || 'EUR';
        const rate = currency === 'EUR' ? 1 : Number(window.Shopify?.currency?.rate);
        if (!(rate > 0) || (currency !== 'EUR' && window.Shopify?.currency?.active !== currency)) {
          const euros = new Intl.NumberFormat(this.dataset.locale || 'es', { style: 'currency', currency: 'EUR' });
          message.textContent = this.dataset.converted.replace('[amount]', euros.format(threshold / 100)).replace('[region]', name);
          return;
        }
        const target = Math.ceil(threshold * rate);
        const format = new Intl.NumberFormat(this.dataset.locale || 'es', { style: 'currency', currency });
        const total = Math.max(0, Number(this.dataset.total) || 0);
        const remaining = Math.max(0, target - total);
        message.textContent = remaining > 0
          ? this.dataset.remaining.replace('[amount]', format.format(remaining / 100))
          : this.dataset.unlocked;
        const progress = this.querySelector('[role="progressbar"]');
        const next = Math.min(100, total / target * 100);
        const key = `${this.scope}:${currency}:${region}`;
        const previous = this.constructor.previousProgress.get(key) || 0;
        this.progressKey = key;
        this.targetProgress = next;
        this.constructor.previousProgress.set(key, next);
        progress.setAttribute('aria-valuenow', String(Math.round(next)));
        progress.setAttribute('aria-valuetext', message.textContent);
        this.querySelector('[data-rv-shipping-goal]').textContent = format.format(target / 100);
        this.querySelector('.rv-shipping__scale span').textContent = format.format(0);
        this.hidden = false;
        meter.hidden = false;
        if (this.drawer && !this.drawer.classList.contains('active')) {
          this.fill.style.transform = 'scaleX(0)';
        } else {
          this.animateProgress(previous, next);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
